<!-- 🔵 FOOTER SUPERIOR -->
<div class="footer-top container-fluid py-4">

  <div class="row">

    <!-- Dirección -->
    <div class="col-md-4">
      <h5>Dirección</h5>
      <p>
        85 SN Unidad Esfuerzo y Trabajo 1, 85 SN, Unidad Esfuerzo y Trabajo 1, <br> 24350 Escárcega, Camp.
      </p>

      <h5>Contacto</h5>
      <p>
        Número: 982 688 1598 EXT.500
      </p>
    </div>

    <!-- Enlaces -->
    <div class="col-md-4">
      <h5>Enlaces</h5>
      <p><a href="https://portaltransparencia.gob.mx/buscador/search/search.do?method=begin" target="_blank">Portal de Obligaciones de Transparencia</a></p>
      <p>INAI</p>
      <p>Buzón de Sugerencias</p>

    
    </div>

    <!-- Mapa -->
    <div class="col-md-4">
    <iframe
  src="https://www.google.com/maps?q=TECNM+Campus+Esc%C3%A1rcega&z=17&output=embed"
  width="100%"
  height="350"
  style="border:0;"
  loading="lazy">
</iframe>
    </div>

  </div>

  <!-- Aviso -->
  <div class="text-center mt-3">
    <p class="mb-0">Aviso de Privacidad</p>
    <small>Última actualización: 15/01/2025</small>
  </div>

</div>

<!-- 🔴 FOOTER INFERIOR -->
<div class="footer-bottom container-fluid py-4">

  <div class="row align-items-center">

    <!-- Logo -->
    <div class="col-md-3 text-center">
      <img src="https://framework-gb.cdn.gob.mx/landing/img/logoheader.svg" class="logo-footer"
        alt="Gobierno de México">
    </div>

    <!-- Enlaces -->
    <div class="col-md-3">
      <h5>Enlaces</h5>
      <ul class="list-unstyled">
        <li><a href="https://data.buengobierno.gob.mx/databuengobierno" target="_blank" rel="noopener noreferrer">Datos abiertos de la SABG</a></li>
        <li><a href="http://www.ordenjuridico.gob.mx/" target="_blank" rel="noopener noreferrer">Marco Jurídico</a></li>
        <li><a href="https://consultapublicamx.plataformadetransparencia.org.mx/vut-web/faces/view/consultaPublica.xhtml#inicio" target="_blank" rel="noopener noreferrer">Plataforma Nacional de Transparencia</a></li>
        <li><a href="https://transparencia.gob.mx/home.html" target="_blank" rel="noopener noreferrer">Transparencia para el pueblo</a></li>
        <li><a href="https://alertadores.buengobierno.gob.mx/" target="_blank" rel="noopener noreferrer">Alerta</a></li>
      </ul>
    </div>

    <!-- gob.mx -->
    <div class="col-md-3">
      <h5>¿Qué es gob.mx?</h5>
      <p>
        Es el portal único de trámites, información y participación ciudadana.
       
      </p>

      <p>Portal de datos abiertos</p>
      <p>Declaración de accesibilidad</p>
      <p>Términos y Condiciones</p>
    </div>

    <!-- Redes -->
    <div class="col-md-3">
      <h5>Denuncia contra servidores públicos</h5>

      <h6 class="mt-3">Síguenos en</h6>
      <div class="d-flex gap-3 fs-4 social-icons">
            <a href="https://www.facebook.com/gobmexico" target="_blank" rel="noopener noreferrer">
              <i class="bi bi-facebook"></i>
            </a>

            <a href="https://twitter.com/GobiernoMX" target="_blank" rel="noopener noreferrer">
              <i class="bi bi-twitter-x"></i>
            </a>

            <a href="https://www.instagram.com/gobmexico/" target="_blank" rel="noopener noreferrer">
              <i class="bi bi-instagram"></i>
            </a>

            <a href="https://www.youtube.com/@gobiernodemexico" target="_blank" rel="noopener noreferrer">
              <i class="bi bi-youtube"></i>
            </a>
          </div>

      <a href="tel:+079" class="mt-3 d-flex align-items-center gap-2 text-white text-decoration-none">
        <span class="numero">079</span>
        <small>Comunícate, estamos para ayudarte</small>
      </a>
    </div>

  </div>

</div>